import { CONTACT } from "@/lib/content";
import { Reveal } from "@/components/Reveal";

export default function Footer() {
    return (
        <footer
            className="relative border-t border-white/10 bg-navy-950 px-6 py-20 md:px-12"
            data-testid="footer"
        >
            <div className="mx-auto max-w-7xl">
                <Reveal>
                    <p className="font-display text-2xl md:text-4xl font-light leading-snug text-white/90 max-w-3xl">
                        A radically better way to do the one thing{" "}
                        <span className="italic text-gold">
                            every family should do.
                        </span>
                    </p>
                </Reveal>

                <div className="mt-16 grid gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
                    <div>
                        <img
                            src="/heir-mark-gold.svg"
                            alt="HEIR"
                            className="h-10 w-10 object-contain"
                        />
                        <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">
                            Confidential · For Qualified Investors Only
                        </p>
                    </div>

                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Contact
                        </p>
                        <a
                            href={CONTACT.mailto}
                            data-testid="footer-contact-email"
                            className="mt-3 inline-block text-white/70 transition-colors hover:text-gold"
                        >
                            {CONTACT.email}
                        </a>
                    </div>

                    <div>
                        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                            Entity
                        </p>
                        <p className="mt-3 text-white/70">
                            HEIR PTE. LTD.
                            <br />
                            Singapore
                        </p>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 md:flex-row md:items-center">
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
                        © {new Date().getFullYear()} HEIR PTE. LTD.
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
                        Private Placement · Singapore
                    </p>
                </div>
            </div>
        </footer>
    );
}
